import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { useHistory } from 'react-router-dom';
import { addAttendeeToSession } from './attendee_actions';
import { FormGroup } from 'react-bootstrap';

export default function Survey({showModal, setShowSurvey, thisUser}) {
    const chosenSession = localStorage.getItem("currentSession");
    const questions = ["Your location", "Is English your first language?", "Age", "Housing", "Racial identity", "If other racial identity, explain:"]
    const [answers, setAnswers] = useState({
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
        6: ""
    });
    const [validated, setValidated] = useState(false);
    const show = showModal;
    const history = useHistory();
    const mountedRef = useRef(false);

    const handleClose = () => {
        let valid = true
        if(!submittedRequiredQuestion()){
            valid = false;
            alert('Please submit a valid location');
        }
        if(valid && thisUser && chosenSession && mountedRef.current){
            addAttendeeToSession(thisUser.uid, chosenSession, {questions: questions, answers: answers})
            setShowSurvey(false); 
            history.push("/attendee");
        }
    };

    const submittedRequiredQuestion = () => {
        if(answers[1] == ""){
            return false;
        }
        return true
    }

    const handleAnswerChange= (event, answer) => {
        const newAnswers = {...answers};
        if(answer) {
            newAnswers[event] = answer;
        }
        else {
            newAnswers[event.target.id] = event.target.value;
        }
        if(mountedRef.current) setAnswers(newAnswers);
    }

    useEffect(() => {
        mountedRef.current = true;
        return () => {mountedRef.current = false;}
    }, [])

    return (
        <>
            <Modal show={show} onHide={() => setShowSurvey(false)} centered>
                <Modal.Header closeButton>
                    <div>
                    <Modal.Title>Help us get to know you!</Modal.Title>
                    <p className="mb-0"> The Town of Amherst is committed to help the community. In order to understand and address our community's needs, we need to hear your voice! Please help us by introducing yourself and engaging with the town</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Col} md="6" controlId="1" className="px-0">
                        <Form.Label>{questions[0]} <span className="text-danger">*</span> </Form.Label>
                        <Form.Control as="select" defaultValue={answers[1]} onChange={handleAnswerChange} required>
                            <option value="">Choose a location</option>
                            <option value="Amherst Center">Amherst Center</option>
                            <option value="North Amherst">North Amherst</option>
                            <option value="South Amherst">South Amherst</option>
                            <option value="Outside of Amherst">Outside of Amherst</option>
                        </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="2" className="px-0">
                        <Form.Label>{questions[1]} <span className=""> (optional)</span> </Form.Label>
                        <Form.Control as="select" defaultValue={answers[2]} onChange={handleAnswerChange}>
                            <option value="">Choose an answer</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </Form.Control>
                        </Form.Group>
                        
                        <Form.Group as={Col} md="3" controlId="3" className="px-0">
                            <Form.Label>{questions[2]} <span className=""> (optional)</span> </Form.Label>
                            <Form.Control type="number" min="1" max-="120" placeholder="Age" defaultValue={answers[3]} onChange={handleAnswerChange}/>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="4" className="px-0">
                        <Form.Label>{questions[3]} <span className=""> (optional)</span> </Form.Label>
                        <Form.Control as="select" defaultValue={answers[4]} onChange={handleAnswerChange}>
                            <option value="">Choose an answer</option>
                            <option value="Own">Own</option>
                            <option value="Rent">Rent</option>
                            <option value="Other">Other</option>
                        </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="5" className="px-0">
                        <Form.Label>{questions[4]} <span className=""> (optional)</span> </Form.Label>
                        <Form.Control as="select" defaultValue={answers[5]} onChange={handleAnswerChange}>
                            <option value="">Choose an answer</option>
                            <option value="White">White</option>
                            <option value="Black or African American">Black or African American</option>
                            <option value="Native American/Alaska Native">Native American/Alaska Native</option>
                            <option value="Asian">Asian</option>
                            <option value="Native Hawaiian/Other Pacific Islander">Native Hawaiian/Other Pacific Islander</option>
                            <option value="Other">Other</option>
                        </Form.Control>
                        </Form.Group>
            
                        {answers[5] === "Other" && <Form.Group as={Col} md="6" controlId="6" className="px-0">
                            <Form.Label>{questions[5]} <span className=""> (optional)</span> </Form.Label>
                            <Form.Control type="text" onChange={handleAnswerChange}/>
                        </Form.Group>}

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button value="primary" onClick={handleClose}>
                    Submit
                </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
